<template>
  <div class="detail-section-inner">
    <div class="detail-img">
      <div class="main-img-wrap" :class="{ 'is-placeholder': isPlaceholder }">
        <img class="main-img" :src="mainImgSrc" alt="" @error="onMainImgError" />
      </div>
      <!-- 사진이 2장 이상일 때만 (1장이면 큰 사진과 같은 사진이라 숨김) -->
      <div class="sub-imgs" v-if="safeImgSrc.length > 1">
        <button
            type="button"
            class="sub-img-wrap"
            :class="{ 'is-active': src === mainImgSrc }"
            v-for="(src, index) in safeImgSrc"
            :key="(storeProps.id != null ? storeProps.id : 's') + '-' + index"
            @click.prevent="onSubImgClick(src)"
        >
          <img :data-alt="index + 1" class="sub-img" :src="src" alt="" />
        </button>
      </div>
    </div>
    <div class="detail-ttl">
      <h3>{{ storeProps.name }}</h3>
<!--      <div class="classify-items">-->
<!--        <em class="classify-item">-->
<!--          <div class="store-icon-wrap ear-icon-wrap earaidIcon">-->
<!--            <img src="https://img.davich.com/image/sub/support/map/icon-store-all.png" alt="car icon" />-->
<!--          </div>-->
<!--          <span>보청기</span>-->
<!--        </em>-->
<!--        <em class="classify-item">-->
<!--          <div class="store-icon-wrap car-icon-wrap parkingIcon parkingIcon">-->
<!--            <img src="https://img.davich.com/image/sub/support/map/icon-store-all.png" alt="car icon" />-->
<!--          </div>-->
<!--          <span>주차장</span>-->
<!--        </em>-->
<!--        <em class="classify-item">-->
<!--          <div class="store-icon-wrap lens-icon-wrap lensIcon">-->
<!--            <img src="https://img.davich.com/image/sub/support/map/icon-store-all.png" alt="lens icon" />-->
<!--          </div>-->
<!--          <span>렌즈샵</span>-->
<!--        </em>-->
<!--      </div>-->
    </div>
    <!-- 매장 정보: 요약 시트와 같은 모양 (아이콘 + 글자 한 줄씩) -->
    <ul class="store-info">
      <li>
        <img class="store-info-icon" src="@/assets/icons/map@2x-100.jpg" alt="주소" />
        <span class="store-info-text">{{ storeProps.addr }}</span>
        <button type="button" class="store-info-copy" @click="copyToClipboard">주소복사</button>
      </li>
      <li v-if="storeProps.tel">
        <img class="store-info-icon" src="@/assets/icons/call@2x-100.jpg" alt="전화번호" />
        <span class="store-info-text">{{ storeProps.tel }}</span>
      </li>
<!--      <p class="detail-site" v-if="storeProps.blogUrl">-->
<!--        <span class="store-icon-wrap detail-store-icon-wrap site-icon-wrap siteIcon">-->
<!--          <img src="https://img.davich.com/image/sub/support/map/icon-store-all.png" alt="site icon" />-->
<!--        </span>-->
<!--        <a :href="storeProps.blogUrl" target="_blank"-->
<!--          ><span>{{ storeProps.blogUrl }}</span></a-->
<!--        >-->
<!--      </p>-->
      <li v-if="storeProps.workHour">
        <img class="store-info-icon" src="@/assets/icons/home@2x-100.jpg" alt="영업시간" />
        <span class="store-info-text">{{ storeProps.workHour }}</span>
      </li>
      <li v-if="storeProps.locationInfo">
        <img class="store-info-icon" src="@/assets/icons/sign@2x-100.jpg" alt="찾아오는 길" />
        <span class="store-info-text">{{ storeProps.locationInfo }}</span>
      </li>
      <li>
        <img class="store-info-icon" src="@/assets/icons/gift@2x-100.jpg" alt="제휴 할인" />
        <span class="store-info-text">교원상조 10% 할인, 경찰공제회 10% 할인</span>
      </li>
      <li>
        <img class="store-info-icon" src="@/assets/icons/notice@2x-100.jpg" alt="안내" />
        <span class="store-info-text">무료 청력검사, 보청기 무료체험 가능</span>
      </li>
      <li>
        <img class="store-info-icon" src="@/assets/icons/ticket@2x-100.jpg" alt="예약 안내" />
        <span class="store-info-text">원활한 1:1 상담을 위해 사전 예약 필수</span>
      </li>
      <!-- 매장별 제휴 할인 (등록된 매장만) -->
      <li v-if="safeDiscount.length">
        <span class="store-icon-wrap saleIcon">
          <img src="https://img.davich.com/image/sub/support/map/icon-store-all.png" alt="할인" />
        </span>
        <span class="store-info-text">
          <span v-for="dcItem in safeDiscount" :key="dcItem.id" class="store-info-sale"
            ><strong>{{ dcItem.dc_rate }}% 할인</strong>{{ dcItem.ven_name }}</span
          >
        </span>
      </li>
    </ul>
    <div class="kakao-reserv-btns" ref="reservBtnArea">
      <button v-if="pickMode" type="button" class="pick-btn" @click="$emit('pick')">이 매장 선택</button>
      <template v-else>

        <router-link :to="consultLink" class="kakao-btn">
          <div class="store-icon-wrap kakao-icon-wrap kakaoIcon">
            <img src="https://img.davich.com/mobile/image/sub/support/map/icon-store-all-01.png" alt="kakao icon" />
          </div>
          <span>상담예약</span>
        </router-link>

        <a
            v-if="storeProps.naverUrl"
            :href="storeProps.naverUrl"
            target="_blank"
            class="visit-btn"
        >
          <div class="store-icon-wrap reserv-icon-wrap reservIcon">
            <img src="https://img.davich.com/mobile/image/sub/support/map/icon-store-all-02.png" alt="reservation icon" />
          </div>
          <span>방문예약</span>
        </a>

        <router-link
            v-else
            :to="consultLink"
            class="visit-btn"
        >
          <div class="store-icon-wrap reserv-icon-wrap reservIcon">
            <img src="https://img.davich.com/mobile/image/sub/support/map/icon-store-all-02.png" alt="reservation icon" />
          </div>
          <span>방문예약</span>
        </router-link>
      </template>
    </div>
  </div>
</template>

<script>
import { consultationLink, copyAddress } from "@/utils/storeFinder";

const MAIN_IMG_PLACEHOLDER =
  "https://img.davichmarket.com/uploads/legacy/image/logo/davich.jpg";

export default {
  data() {
    return {
      reservBtnAreaObserver: null,
      mainImgUseFallback: false,
      /** 썸네일 클릭 시 메인 이미지(매장 변경 시 watch에서 초기화) */
      mainPreviewSrc: null,
    };
  },
  props: {
    // 신청서에서 매장 고르기: 아래 버튼을 [이 매장 선택] 하나로
    pickMode: { type: Boolean, default: false },
    storeProps: {
      type: Object,
      default: () => ({
        id: null,
        strCode: "",
        name: "",
        lat: null,
        lng: null,
        addr: "",
        tel: "",
        tag: [],
        blogUrl: "",
        kakaoUrl: "",
        naverUrl: "",
        locationInfo: "",
        workHour: "",
        imgSrc: [],
        discount: [],
      }),
    },
  },
  computed: {
    consultLink() {
      return consultationLink(this.storeProps.strCode);
    },
    safeImgSrc() {
      return Array.isArray(this.storeProps.imgSrc) ? this.storeProps.imgSrc : [];
    },
    safeDiscount() {
      return Array.isArray(this.storeProps.discount) ? this.storeProps.discount : [];
    },
    mainImgSrc() {
      const preview =
          typeof this.mainPreviewSrc === "string" && this.mainPreviewSrc.trim()
              ? this.mainPreviewSrc.trim()
              : "";
      if (preview) return preview;

      const raw = this.safeImgSrc && this.safeImgSrc[0];
      const url =
          typeof raw === "string" && raw.trim() ? raw.trim() : "";
      if (this.mainImgUseFallback || !url) {
        return MAIN_IMG_PLACEHOLDER;
      }
      return url;
    },
    // 사진이 없거나 못 불러와서 로고를 보여주는 중
    isPlaceholder() {
      return this.mainImgSrc === MAIN_IMG_PLACEHOLDER;
    },
  },
  watch: {
    storeProps: {
      handler() {
        this.mainImgUseFallback = false;
        this.mainPreviewSrc = null;
      },
      deep: true,
    },
  },
  mounted() {
    window.addEventListener("load", this.setScreenSize);
    window.addEventListener("resize", this.setScreenSize);

    // 최초 1회 적용 및 ResizeObserver 설정
    this.$nextTick(() => {
      this.initializeHeightObservers();
    });
  },
  methods: {
    onMainImgError() {
      if (this.mainImgUseFallback) return;
      this.mainImgUseFallback = true;
    },
    onSubImgClick(src) {
      this.mainImgUseFallback = false;
      this.mainPreviewSrc =
          typeof src === "string" && src.trim() ? src.trim() : null;
    },
    // 아래 상담예약·방문예약 버튼 높이 → 상세 스크롤 영역 높이 계산에 사용
    initializeHeightObservers() {
      if (!window.ResizeObserver) return;

      // 예약 버튼 영역 높이 감지
      const reservBtnEl = this.$refs.reservBtnArea;
      if (reservBtnEl) {
        this.reservBtnAreaObserver = new ResizeObserver((entries) => {
          const height = entries[0].target.offsetHeight;
          document.documentElement.style.setProperty('--reserv-btn-area-height', `${height}px`);
        });
        this.reservBtnAreaObserver.observe(reservBtnEl);
      }
    },

    copyToClipboard() {
      copyAddress(this.storeProps && this.storeProps.addr);
    },

    // 버튼 하단 위치
    setScreenSize() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    },
  },
  beforeDestroy() {
    // ResizeObserver 정리
    if (this.reservBtnAreaObserver) {
      this.reservBtnAreaObserver.disconnect();
      this.reservBtnAreaObserver = null;
    }

    // 리사이즈 이벤트 제거
    window.removeEventListener("load", this.setScreenSize);
    window.removeEventListener("resize", this.setScreenSize);
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/helpers/variables";
@import "~@/assets/scss/helpers/mixins";
@import "~@/assets/scss/base/typhography";

.m-find-store {
  .detail-section-inner {
    height: calc(var(--vh, 1vh) * 100 - 52px - var(--reserv-btn-area-height, 61px));
    margin: 32px -20px 0;
    padding: 0 20px 16px;
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
  }
  // 큰 사진·썸네일 모두 3:2 (매장 사진은 대부분 4:3이라 위아래만 조금 잘림)
  .detail-img {
    .main-img-wrap {
      width: 100%;
      aspect-ratio: 3 / 2;
      background-color: #f4f5f8;
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      // 사진이 없는 매장: 정사각형 로고(흰 바탕)가 잘리지 않게 전체를, 흰 바탕 + 옅은 테두리로
      &.is-placeholder {
        border: 1px solid #eee;
        background-color: $color-white;
        img {
          padding: 16px;
          object-fit: contain;
        }
      }
    }
    // 한 줄에 4칸, 지금 크게 보고 있는 사진은 파란 테두리
    .sub-imgs {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 6px;
      margin-top: 6px;
      .sub-img-wrap {
        position: relative;
        display: block;
        min-width: 0;
        min-height: 0;
        padding: 0;
        aspect-ratio: 3 / 2;
        overflow: hidden;
        background-color: #f4f5f8;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        &::after {
          content: "";
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          border: 2px solid transparent;
          pointer-events: none;
        }
        &.is-active::after {
          border-color: $color-blue;
        }
      }
    }
    // aspect-ratio를 모르는 오래된 브라우저: 예전 높이로
    @supports not (aspect-ratio: 1 / 1) {
      .main-img-wrap {
        height: 300px;
        @media screen and (max-width: 480px) {
          height: 220px;
        }
      }
      .sub-img-wrap {
        height: 60px;
      }
    }
  }
  .detail-ttl {
    padding: 22px 0 10px;
    h3 {
      font-weight: bold;
      font-size: 20px;
      line-height: 28px;
      letter-spacing: -0.3px;
      color: #222;
      word-break: keep-all;
    }
    .classify-items {
      display: flex;
      .classify-item {
        display: flex;
        span {
          font-size: 15px;
        }
      }
    }
  }
  // 매장 정보 줄: 요약 시트(StoreFinder)와 상세가 같이 쓴다
  .store-info {
    li {
      display: flex;
      align-items: flex-start;
      padding: 5px 0;
      font-size: 15px;
      line-height: 22px;
      color: #555;
    }
    .store-info-icon {
      flex-shrink: 0;
      width: 20px;
      height: 20px;
      margin: 1px 8px 0 0;
    }
    .store-info-text {
      flex: 1;
      min-width: 0;
      word-break: keep-all;
      overflow-wrap: anywhere;
    }
    // 주소복사: "사진·상세 정보 보기"·검색창과 같은 연회색, 사이트 버튼처럼 각지게
    .store-info-copy {
      flex-shrink: 0;
      min-width: 0;
      min-height: 0;
      height: 28px;
      margin: -3px 0 0 10px;
      padding: 0 10px;
      background-color: #f4f5f8;
      font-size: 13px;
      font-weight: 500;
      line-height: 28px;
      color: #555;
      white-space: nowrap;
    }
    .saleIcon {
      flex-shrink: 0;
      margin: 0 7px 0 0;
    }
    .store-info-sale {
      display: block;
      color: $color-blue;
      & + .store-info-sale {
        margin-top: 6px;
      }
      strong {
        display: inline-block;
        margin-right: 6px;
        padding: 0 6px;
        border: 1px solid $color-blue;
        font-size: 13px;
        line-height: 20px;
      }
    }
  }
  .kakao-reserv-btns {
    // [이 매장 선택] (요약 시트·상세 공통): 방문예약 버튼과 같은 파란색
    .pick-btn {
      display: block;
      width: 100%;
      min-height: 0;
      height: 60px;
      background-color: $color-blue;
      color: $color-white;
      font-size: 17px;
      font-weight: 500;
    }
    position: absolute;
    width: 100%;
    top: calc(var(--vh, 1vh) * 100 - 60px);
    // bottom: 0px;
    left: 0;
    background-color: #fff;
    display: table;
    border-collapse: collapse;
    text-align: center;
    font-size: 17px;
    //safari에서 안나올때
    // -webkit-backface-visibility:hidden;
    // -webkit-transform:translateZ(0);
    // -webkit-transform:translate3d(0, 0, 0);

    .kakao-btn {
      width: 50%;
      display: table-cell;
      height: 60px;
      line-height: 60px;
      .kakaoIcon {
        margin-bottom: -3px;
        width: 24px;
        height: 19px;
        img {
          width: 100%;
        }
      }
    }
    .visit-btn {
      width: 50%;
      display: table-cell;
      height: 60px;
      line-height: 60px;
      background-color: $color-blue;
      color: $color-white;
      .reservIcon {
        width: 22px;
        height: 22px;
        margin-bottom: -4px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    a {
      flex: 1;
      height: 60px;
      border-top: 1px solid #aaa;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        margin-right: 5px;
      }
    }a.visit-btn:nth-child(2){
           border-color:$color-blue;
         }
  }
  // 이미지 모음
  .store-icon-wrap {
    position: relative;
    overflow: hidden;
    margin-right: 5px;
    display: inline-block;
    img {
      position: absolute;
    }
    //분류
    &.wifiIcon {
      width: 21px;
      height: 21px;
      img {
        left: 0px;
        top: 0px;
      }
    }
    &.earaidIcon {
      width: 21px;
      height: 21px;
      img {
        left: -43px;
        top: 0;
      }
    }
    &.fittingIcon {
      width: 22px;
      height: 21px;
      img {
        left: -64px;
        top: -22px;
      }
    }
    &.lensIcon {
      width: 23px;
      height: 21px;
      img {
        left: -85px;
        top: 0px;
      }
    }
    &.parkingIcon {
      width: 23px;
      height: 21px;
      img {
        left: -85px;
        top: -22px;
      }
    }
    //정보
    &.addressIcon {
      width: 21px;
      height: 21px;
      img {
        left: 0px;
        top: -22px;
      }
    }
    &.phoneIcon {
      width: 21px;
      height: 21px;
      img {
        left: -22px;
        top: 0px;
      }
    }
    &.siteIcon {
      width: 21px;
      height: 21px;
      img {
        left: -21px;
        top: -22px;
      }
    }
    &.locationIcon {
      width: 22px;
      height: 21px;
      img {
        left: -42px;
        top: -22px;
      }
    }
    &.saleIcon {
      width: 21px;
      height: 21px;
      img {
        left: -64px;
        top: 0;
      }
    }
    //버튼
    &.kakaoIcon {
      // width: 26px;
      // height: 21px;
      img {
        left: 0px;
        top: 0px;
      }
    }
    &.reservIcon {
      // width: 16px;
      // height: 21px;
      img {
        left: 0px;
        top: 0px;
      }
    }
  }
}
</style>
